module.exports = __webpack_public_path__ + "static/media/project-folder.e8085b1c.svg";